import config from '../config/config';

class UserService {
  constructor() {
    this.baseURL = config.API_BASE_URL;
  }

  // Get user profile
  async getProfile() {
    try {
      const response = await fetch(`${this.baseURL}/api/website-user/profile`, {
        method: 'GET',
        credentials: 'include', // Include cookies
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to fetch profile');
      }

      return {
        success: true,
        data: data.data,
      };
    } catch (error) {
      
      return {
        success: false,
        error: error.message || 'Failed to fetch profile',
      };
    }
  }

  // Update user profile
  async updateProfile(profileData) {
    try {
      const response = await fetch(`${this.baseURL}/api/website-user/profile`, {
        method: 'PUT',
        credentials: 'include', // Include cookies
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(profileData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to update profile');
      }

      return {
        success: true,
        data: data.data,
      };
    } catch (error) {
      
      return {
        success: false,
        error: error.message || 'Failed to update profile',
      };
    }
  }

  // Change password
  async changePassword(passwordData) {
    try {
      const response = await fetch(`${this.baseURL}/api/website-user/change-password`, {
        method: 'POST',
        credentials: 'include', // Include cookies
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(passwordData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to change password');
      }

      return {
        success: true,
        message: data.message,
      };
    } catch (error) {
      
      return {
        success: false,
        error: error.message || 'Failed to change password',
      };
    }
  }

  // Check authentication status
  async checkAuth() {
    try {
      // Get token from cookies
      const token = document.cookie.split('; ').find(row => row.startsWith('token='));
      
      if (!token) {
        return {
          success: false,
          error: 'No token found',
        };
      }

      const tokenValue = token.split('=')[1];

      // Try admin/member unified endpoint with Authorization header
      const response = await fetch(`${this.baseURL}/api/admin/auth/me`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${tokenValue}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        return {
          success: true,
          data: {
            user: data.data
          },
        };
      } else {
        return {
          success: false,
          error: 'Not authenticated',
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Authentication check failed',
      };
    }
  }
}

export default new UserService();